<div class="main-container" [class.simplified-mode]="simplifiedMode">
  <div class="drag-handle" *ngIf="!simplifiedMode">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M11 18C11 19.1 10.1 20 9 20C7.9 20 7 19.1 7 18C7 16.9 7.9 16 9 16C10.1 16 11 16.9 11 18ZM9 10C7.9 10 7 10.9 7 12C7 13.1 7.9 14 9 14C10.1 14 11 13.1 11 12C11 10.9 10.1 10 9 10ZM9 4C7.9 4 7 4.9 7 6C7 7.1 7.9 8 9 8C10.1 8 11 7.1 11 6C11 4.9 10.1 4 9 4ZM15 8C16.1 8 17 7.1 17 6C17 4.9 16.1 4 15 4C13.9 4 13 4.9 13 6C13 7.1 13.9 8 15 8ZM15 10C13.9 10 13 10.9 13 12C13 13.1 13.9 14 15 14C16.1 14 17 13.1 17 12C17 10.9 16.1 10 15 10ZM15 16C13.9 16 13 16.9 13 18C13 19.1 13.9 20 15 20C16.1 20 17 19.1 17 18C17 16.9 16.1 16 15 16Z" fill="black" fill-opacity="0.56"/>
    </svg>
  </div>

  <div class="poster-image" [style.backgroundImage]="'url(' + (course.postermedia?.path || '/assets/wonda/background2_ld.jpg')  + ')'">
  </div>

  <div class="content-container">
    <div class="info-container">
      <div class="title text-truncate programs-h5">{{ course.title }}</div>
      <div class="description programs-subtitle-1">{{ course.description }}</div>
      <div class="bottom-bar programs-body-1" *ngIf="!simplifiedMode">
        <button mat-raised-button color="primary" (click)="launchCourse()">
          <mat-icon fontSet="fa" fontIcon="fa-play"></mat-icon>
          LAUNCH
        </button>
        <button mat-stroked-button color="primary" (click)="goToCourse()">
          <mat-icon>edit</mat-icon>
          EDIT
        </button>
        <button mat-stroked-button color="primary" (click)="goToAssessments()">
          <mat-icon fontSet="fa" fontIcon="fa-award"></mat-icon>
          REPORTS
        </button>
      </div>
    </div>
  </div>

  <!-- Menu -->
  <div (click)="$event.stopPropagation()" class="menu" *ngIf="!simplifiedMode">
    <div mat-button [matMenuTriggerFor]="menu">
      <mat-icon class="options-menu-icon">more_vert</mat-icon>
    </div>
    <mat-menu #menu="matMenu" xPosition="before" yPosition="below">
      <button mat-menu-item class="mat-menu" plan-limit [canDo]="canEnter(course)" (click)="openEmbedDialog(course)">
        <mat-icon>share</mat-icon>
        <span>SHARE {{ course.experience_type | courseLabel | uppercase }}</span>
      </button>
      <button mat-menu-item class="mat-menu" plan-limit [canDo]="canCreateCourse" (click)="duplicateCourse(course?.id)" matTooltipPosition="left">
        <mat-icon>photo_library</mat-icon>
        <span>DUPLICATE</span>
      </button>
      <div *ngIf="userCanMove()" plan-limit [canDo]="moveEnabled()" matTooltipPosition="left" class="sub-menu-button-container">
        <button [disabled]="!moveEnabled()" mat-menu-item class="mat-menu" [matMenuTriggerFor]="spaceListMenu">
          <mat-icon>folder</mat-icon>
          <span>MOVE</span>
        </button>
      </div>
      <button (click)="openLMSDialog(course)" mat-menu-item  class="mat-menu" plan-limit [canDo]="canUseLMS()" [customTooltip]="'Upgrade to integrate with LMS'" matTooltipPosition="left">
        <mat-icon>school</mat-icon>
        <span>LMS EXPORT</span>
      </button>
      <button *ngIf="canDelete(course.user_id)" mat-menu-item class="mat-menu" (click)="deleteCourse(course)">
        <mat-icon>delete</mat-icon>
        <span>DELETE</span>
      </button>
    </mat-menu>
  </div>
  <mat-menu #spaceListMenu="matMenu" xPosition="before" yPosition="below">
    <ng-template matMenuContent>
      <ng-container *ngFor="let space of learnspaceList">
        <button *ngIf="space.id !== course.learnspace_id" mat-menu-item class="mat-menu" (click)="moveCourse(space, course)"> {{ space.title }}</button>
      </ng-container>
    </ng-template>
  </mat-menu>
</div>